import { AbstractControl, AsyncValidatorFn, ValidationErrors, ValidatorFn } from '@angular/forms';
import { Observable, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, map, take, takeUntil } from 'rxjs/operators';

export function unicityValidator(
	service: (value: string) => Observable<boolean>,
	errorType: string,
	destroySubscriptions$: Subject<boolean>
): AsyncValidatorFn {
	return (control: AbstractControl): Observable<ValidationErrors | null> => {
		return service(control.value).pipe(
			debounceTime(400),
			distinctUntilChanged(),
			takeUntil(destroySubscriptions$),
			take(1),
			map(res => {
				return res ? null : { [errorType]: true };
			})
		);
	};
}

export function requiredOneOrOther(controlB: AbstractControl, errorType: string): ValidatorFn {
	return (control: AbstractControl): ValidationErrors | null => {
		return controlB.value || control.value ? null : { [errorType]: true };
	};
}
